/**
 * Client-side fitment attribute validation (mirrors backend fitment_profiles.json).
 */
const PROFILE_REQUIRED = {
  A: ['refrigerant', 'mountPosition'],
  B: ['axlePosition', 'side', 'fuelType'],
  C: ['side'],
  D: ['sizeSpec'],
  E: ['side', 'voltage', 'compatibilityTrim'],
  F: ['universalFit'],
  G: ['volumeLitres', 'gradeSpec'],
};

const FIELD_LABELS = {
  axlePosition: 'Front / Rear',
  side: 'Left / Right',
  fuelType: 'Fuel type',
  sizeSpec: 'Size / specification',
  voltage: 'Voltage',
  compatibilityTrim: 'Compatibility trim',
  refrigerant: 'Refrigerant type',
  mountPosition: 'Mount position',
  universalFit: 'Universal fit',
  volumeLitres: 'Volume (litres)',
  gradeSpec: 'Grade / specification',
};

export function validateFitmentAttrsClient(profile = 'B', fitmentAttrs = {}) {
  const keys = PROFILE_REQUIRED[String(profile || 'B').toUpperCase()] || PROFILE_REQUIRED.B;
  const errors = {};
  for (const key of keys) {
    if (!String(fitmentAttrs[key] ?? '').trim()) {
      errors[key] = `${FIELD_LABELS[key] || key} is required`;
    }
  }
  return errors;
}
